import { handleApiResponse } from '@src/api/apiClient/axiosClient';
import { companySiteApiClient } from '@src/api/company/site/companySiteApiClient';
import { tenantSiteApiClient } from '@src/api/tenant/site/tenantSiteApiClient';
import { TENANT_URL } from '@src/routes/tenant';
import Button from '@src/ui/elements/button/Button';
import { useEffect, useState } from 'react';

function Error404Form({ isTenant }: { isTenant: boolean }) {
  const [topPageLink, setTopPageLink] = useState(TENANT_URL.ARTICLES);

  useEffect(() => {
    const apiClient = isTenant ? tenantSiteApiClient : companySiteApiClient;
    const setupTopPageUrl = async () => {
      const res = await apiClient.topPageUrl();
      handleApiResponse(res, (data) => {
        setTopPageLink(data.url);
      });
    };
    setupTopPageUrl();
  }, [isTenant]);

  return (
    <div className='text-center'>
      <h1 className='mb-1 text-primary-500'>404 Not Found</h1>
      <p className='mb-7 text-lg font-semibold text-[#222222]'>
        指定されたページ（URL）が見つかりません。
      </p>
      <p className='mb-8 text-center text-[#222222]'>URLに間違いがないかご確認ください。</p>
      <div className='max-w-[400px] mx-auto'>
        <Button
          href={topPageLink}
          size='m'
          variant='primary'
          outline
          fullWidth
          fullRounded
        >
          トップページに戻る
        </Button>
      </div>
    </div>
  );
}

export default Error404Form;
